import { UTM_KEYS } from '~/lib/constants/utm-keys'
import { useSessionStorage } from '@/lib/helpers/storage'

export default function({ query }) {
  UTM_KEYS.forEach(key => {
    if (query[key]) {
      useSessionStorage().setItem(key, query[key])
    }
  })
}
